import { Screenmode } from './screenmode'

export class ContactOverlay {
  constructor (settings = {}) {
    this.options = $.extend({
      selectors: {
        pageHeader: '.page-header',
        contactTrigger: '.contact-overlay-trigger',
        closeTrigger: '.contact-overlay__close',
        contactOverlay: '.contact-overlay',
        mainNavigationClose: '.main-navigation__close'
      },
      classes: {
        contactOverlayOpen: 'contact-overlay--open',
        bodyNoScroll: 'is--no-scroll',
        bodyMobileNavigationOpen: 'is--open-mobile-navigation'
      },
      scrollingHeaderTop: {
        xs: 70,
        sm: 70,
        md: 115,
        lg: 150,
        xl: 150
      }
    },
    settings)
  }

  init () {
    const that = this

    that.addEvents()
  }

  addEvents () {
    const that = this
    const contactTrigger = $(that.options.selectors.contactTrigger)
    const closeTrigger = $(that.options.selectors.closeTrigger)
    const contactOverlay = $(that.options.selectors.contactOverlay)
    let resizeTimer

    contactTrigger
      .on({
        click: function (event) {
          event.preventDefault()

          if (contactOverlay.hasClass(that.options.classes.contactOverlayOpen)) {
            that.closeContactOverlay()
          } else {
            that.openContactOverlay()
          }

          return false
        }
      })

    closeTrigger
      .on({
        click: function (event) {
          that.closeContactOverlay()
        }
      })

    $(document)
      .on({
        keyup: function (event) {
          // Press "Escape"
          if (event.keyCode === 27) {
            that.closeContactOverlay()
          }

          // Tab
          if (event.originalEvent.keyCode === 9) {
            const focusedElement = $(this).find(':focus')

            const contactOverlay = $(that.options.selectors.contactOverlay)

            if (focusedElement.closest(that.options.selectors.contactOverlay).length === 0) {
              if (contactOverlay.hasClass(that.options.classes.contactOverlayOpen)) {
                that.closeContactOverlay()
              }
            } else {
              if (!contactOverlay.hasClass(that.options.classes.contactOverlayOpen)) {
                that.openContactOverlay()
              }
            }
          }
        }
      })

    $(window)
      .resize(function () {
        clearTimeout(resizeTimer)

        resizeTimer = setTimeout(function () {
          let contactLayerTop

          const currentBreakpoint = new Screenmode().getCurrentBreakpoint()

          if (currentBreakpoint === 'xs' || currentBreakpoint === 'sm') {
            contactOverlay
              .css('top', '0')
              .css('height', '100vh')
          } else {
            if ($(document).scrollTop() >= that.options.scrollingHeaderTop[currentBreakpoint]) {
              contactLayerTop = $(that.options.selectors.pageHeader).height()
            } else {
              contactLayerTop = $(that.options.selectors.pageHeader).height() - $(document).scrollTop()
            }

            contactOverlay
              .css('top', contactLayerTop + 'px')
              .css('height', 'calc(100vh - ' + contactLayerTop + 'px)')
          }
        }, 250)
      })
  }

  openContactOverlay () {
    const that = this
    const contactOverlay = $(that.options.selectors.contactOverlay)
    const currentBreakpoint = new Screenmode().getCurrentBreakpoint()
    let contactLayerTop
    const body = $('body')

    $(that.options.selectors.mainNavigationClose)
      .trigger('click')

    body
      .removeClass(that.options.classes.bodyMobileNavigationOpen)
      .addClass(that.options.classes.bodyNoScroll)

    if (currentBreakpoint === 'xs' || currentBreakpoint === 'sm') {
      contactOverlay
        .css('top', '')
        .css('height', '')
        .addClass(that.options.classes.contactOverlayOpen)
    } else {
      if ($(document).scrollTop() >= that.options.scrollingHeaderTop[currentBreakpoint]) {
        contactLayerTop = $(that.options.selectors.pageHeader).height()
      } else {
        contactLayerTop = $(that.options.selectors.pageHeader).height() - $(document).scrollTop()
      }

      contactOverlay
        .css('top', contactLayerTop + 'px')
        .css('height', 'calc(100vh - ' + contactLayerTop + 'px)')
        .addClass(that.options.classes.contactOverlayOpen)
    }
  }

  closeContactOverlay () {
    const that = this

    $(that.options.selectors.contactOverlay)
      .removeClass(that.options.classes.contactOverlayOpen)

    $('body')
      .removeClass(that.options.classes.bodyNoScroll)
  }
}

export default ContactOverlay
